import { ArrowUp } from "lucide-react";
import { Link } from "react-router-dom";

const NAV = [
  { label: 'Home', to: '/' },
  { label: 'Who We Are', to: '/who-we-are' },
  { label: 'What We Do', to: '/what-we-do' },
  { label: 'Our Work', to: '/what-we-have-done' },
  { label: 'Team', to: '/team' },
  { label: 'Contact', to: '/contact-us' },
];

export const Footer = () => {
  return (
    <footer className="bg-ink text-paper border-t border-paper/10">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10 py-16 lg:py-24">
        <div className="grid grid-cols-12 gap-8">
          <div className="col-span-12 lg:col-span-5">
            <div className="flex items-center gap-5">
              <img src="/assets/rccd-emblem.png" alt="" aria-hidden="true" className="h-16 lg:h-20 w-auto object-contain" />
              <div className="border-l border-paper/15 pl-5 self-stretch flex flex-col justify-center">
                <div className="font-display text-3xl text-paper tracking-[0.05em]">RCCD</div>
                <div className="mono text-[10px] uppercase tracking-[0.2em] text-paper/55 mt-1.5">
                  <span className="text-primary-glow">A Distinguished</span> Company
                </div>
                <div className="mono text-[10px] uppercase tracking-[0.2em] text-paper/45 mt-1">35+ years · Southern California</div>
              </div>
            </div>
            <p className="mt-8 text-paper/70 max-w-md leading-relaxed">
              Your land development partner in Southern California — with a current focus on land entitlement and executive management.
            </p>
          </div>

          <div className="col-span-6 lg:col-span-2">
            <div className="mono text-[10px] uppercase tracking-[0.22em] text-paper/40">Explore</div>
            <ul className="mt-5 space-y-3 text-base">
              {NAV.map(x => (
                <li key={x.to}><Link to={x.to} className="text-paper/85 hover:text-primary-glow transition-colors">{x.label}</Link></li>
              ))}
            </ul>
          </div>

          <div className="col-span-6 lg:col-span-2">
            <div className="mono text-[10px] uppercase tracking-[0.22em] text-paper/40">Practice</div>
            <ul className="mt-5 space-y-3 text-base">
              {['Land entitlement', 'Specific plans', 'Executive management', 'Agency coordination', 'Real estate'].map(x => (
                <li key={x} className="text-paper/85">{x}</li>
              ))}
            </ul>
          </div>

          <div className="col-span-12 lg:col-span-3">
            <div className="mono text-[10px] uppercase tracking-[0.22em] text-paper/40">Contact</div>
            <ul className="mt-5 space-y-3 text-base">
              <li><a href="tel:7146374405" className="text-paper/85 hover:text-primary-glow">(714) 637-4405</a></li>
              <li><a href="mailto:contact@rccdinc.com" className="text-paper/85 hover:text-primary-glow">contact@rccdinc.com</a></li>
              <li className="text-paper/85">Southern California</li>
              <li className="text-paper/85">Mon — Fri · 8AM to 5PM</li>
            </ul>
          </div>
        </div>

        {/* Giant wordmark */}
        <div className="mt-20 lg:mt-28 overflow-hidden">
          <div className="font-display text-[clamp(5rem,22vw,22rem)] text-paper/10 leading-[0.85] tracking-[-0.05em] select-none">
            RCCD
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-paper/10 flex flex-col md:flex-row gap-4 justify-between items-start md:items-center">
          <div className="mono text-[10px] uppercase tracking-[0.22em] text-paper/50">
            © {new Date().getFullYear()} RCCD, Inc. · Land Development · Southern California
          </div>
          <button onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="mono text-[10px] uppercase tracking-[0.22em] text-paper/80 hover:text-primary-glow inline-flex items-center gap-2">
            Back to top <ArrowUp className="h-3.5 w-3.5" />
          </button>
        </div>
      </div>
    </footer>
  );
};
